import React from 'react';

type ConditionalRenderComponentProps = {
    /**
     * Условие отображение контента.
     */
    condition: boolean;

    /**
     * Контент.
     */
    children?: React.ReactElement | React.ReactElement[];

    /**
     * Компонент для отображения альтернативного контента.
     */
    alternative: React.ReactElement;
};

/**
 * Происходит отображение по принципу:
 *  condition - true => children
 *  condition - false => alternative
 */
export const ConditionalRenderComponent = ({
    condition,
    alternative,
    children,
}: ConditionalRenderComponentProps) => {
    return <>{condition ? children : alternative}</>;
};
